var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caseOptionBlocage",style:(_vm.calculStyleCellule)},[_c('div',{staticClass:"has-text-black has-text-right pd-5px"},[_vm._v(" "+_vm._s(_vm.qteFacesPrevues - _vm.nbFaceNonDispo)+" / "+_vm._s(_vm.qteFacesPrevues)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }